import { DebugEvent } from 'core/DebugEvent';
import { PixiResourceType } from 'app/data/Enums';

interface PixiResourceLoadEventInterface {
	type: PixiResourceType;
	resource: any;
}

export class PixiResourceLoadEvent extends DebugEvent implements PixiResourceLoadEventInterface {
	protected static eventName: string = 'PIXI_RESOURCE_READY_EVENT';
	type: PixiResourceType;
	resource: any;

	constructor(parameters: PixiResourceLoadEventInterface) {
		super(parameters);
	}
}
